window.addEventListener("load", () => {
    let title = document.querySelectorAll(".footer__block-list .h6");
    let ul = document.querySelectorAll(".footer__block-list ul");

    function resize() {
        if (window.innerWidth <901) {
            ul.forEach((val) => {
                val.classList.add("hide");
            });

            title.forEach((val) => {
                if (!val.querySelector("i")) {
                    const icon = document.createElement("i");
                    icon.classList.add("fa-solid", "fa-angle-down");

                    val.appendChild(icon);

                    val.addEventListener("click", () => {
                        val.nextElementSibling.classList.toggle("hide");
                        icon.classList.toggle("fa-angle-down");
                        icon.classList.toggle("fa-angle-up");
                    });
                }
            });
        }
    }

    resize();

    window.addEventListener("resize", resize);
/*slider*/
let slides=  document.querySelectorAll(".flickity-section__carousel");
let btns=document.querySelectorAll(".flickity-section__carousel .flickity-prev-next-button");
  
if(slides){
    slides.forEach(val=>{
      let num=  val.querySelector(".flickity-slider").children.length;
      let btns=val.querySelectorAll(".flickity-prev-next-button");

      if(num>3||num==3){
        btns.forEach(temp=>{
            temp.style.display="block";
        })
      }
      else{
        btns.forEach(temp=>{
            temp.style.display="none";
        })

      }
    })
}
});



document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.flickity-section__carousel');
    carousels.forEach(function(carousel) {
        const slides = carousel.querySelectorAll('.carousel__cell');
        const countDisplay = document.createElement('div');
        countDisplay.classList.add('carousel-count');

        carousel.insertAdjacentElement('afterend', countDisplay);

        function updateCount() {
            const currentIndex = Array.from(slides).findIndex(slide => slide.classList.contains('is-selected'));
            const totalSlides = slides.length;
            
            // Start slide count from 1
            const displayedIndex = currentIndex !== -1 ? currentIndex + 1 : 1;

            countDisplay.textContent = displayedIndex + '/' + totalSlides;
        }

        carousel.addEventListener('click', updateCount);
      carousel.addEventListener('drag',updateCount);
       carousel.addEventListener('touchmove',updateCount);

        updateCount();
    });
});













